import Vue from 'vue'
import util from './common/util'
import moment from 'moment';

Vue.filter('datetime', function (value, pattern = 'YYYY-MM-DD HH:mm') {
  if (!value) return '-';
  return new moment(value).format(pattern);
});

Vue.filter('date', function (value, pattern = 'YYYY-MM-DD') {
  if (!value) return '-';
  return new moment(value).format(pattern);
});

Vue.filter('month', function (value, pattern = 'YYYY年M月') {
  if (!value) return '-';
  return new moment(value).format(pattern);
});
Vue.filter('age', function (value) {
  if (!value) return '-';
  var age = new moment().diff(new moment(value), 'year');
  if (age == 0)
    return '-';
  return Math.abs(age);
});

/*JSZGFLType(命名空间：Tiantianquan.EducationBureau.Domain.Enums.SC.JSZGFLType)*/
Vue.filter('JSZGFLType', function (value) {
  if (!value) return '';
  return enums.JSZGFLType.getText(parseInt(value));
});


/*PasswordHashType(命名空间：Tiantianquan.Infrastructure.Utils.PasswordHashType)*/
Vue.filter('PasswordHashType', function (value) {
  if (!value) return '';
  return enums.PasswordHashType.getText(parseInt(value));
});


/*LockType(命名空间：Tiantianquan.Infrastructure.Webs.Filters.LockType)*/
Vue.filter('LockType', function (value) {
  if (!value) return '';
  return enums.LockType.getText(parseInt(value));
});

/*SchoolType(命名空间：Tiantianquan.EducationBureau.Domain.Enums.SC.SchoolType)*/
Vue.filter('SchoolType', function (value) {
  if (!value) return '';
  return enums.SchoolType.getText(parseInt(value));
});

/*StateCode(命名空间：Tiantianquan.Infrastructure.Webs.Commons.StateCode)*/
Vue.filter('StateCode', function (value) {
  if (!value) return '';
  return enums.StateCode.getText(parseInt(value));
});


/*HttpContentType(命名空间：Tiantianquan.Infrastructure.Webs.Clients.HttpContentType)*/
Vue.filter('HttpContentType', function (value) {
  if (!value) return '';
  return enums.HttpContentType.getText(parseInt(value));
});


/*CardType(命名空间：Tiantianquan.Infrastructure.MockData.Generators.Banks.CardType)*/
Vue.filter('CardType', function (value) {
  if (!value) return '';
  return enums.CardType.getText(parseInt(value));
});


/*RSAType(命名空间：Tiantianquan.Infrastructure.Helpers.Internal.RSAType)*/
Vue.filter('RSAType', function (value) {
  if (!value) return '';
  return enums.RSAType.getText(parseInt(value));
});


/*BearerTokenUsageType(命名空间：IdentityServer4.Validation.BearerTokenUsageType)*/
Vue.filter('BearerTokenUsageType', function (value) {
  if (!value) return '';
  return enums.BearerTokenUsageType.getText(parseInt(value));
});


/*IntrospectionRequestValidationFailureReason(命名空间：IdentityServer4.Validation.IntrospectionRequestValidationFailureReason)*/
Vue.filter('IntrospectionRequestValidationFailureReason', function (value) {
  if (!value) return '';
  return enums.IntrospectionRequestValidationFailureReason.getText(parseInt(value));
});


/*TokenRequestErrors(命名空间：IdentityServer4.Models.TokenRequestErrors)*/
Vue.filter('TokenRequestErrors', function (value) {
  if (!value) return '';
  return enums.TokenRequestErrors.getText(parseInt(value));
});


/*EventTypes(命名空间：IdentityServer4.Events.EventTypes)*/
Vue.filter('EventTypes', function (value) {
  if (!value) return '';
  return enums.EventTypes.getText(parseInt(value));
});


/*NameType(命名空间：Microsoft.Extensions.DependencyInjection.NameType)*/
Vue.filter('NameType', function (value) {
  if (!value) return '';
  return enums.NameType.getText(parseInt(value));
});


/*ScopeRequirement(命名空间：IdentityServer4.Constants+ScopeRequirement)*/
Vue.filter('ScopeRequirement', function (value) {
  if (!value) return '';
  return enums.ScopeRequirement.getText(parseInt(value));
});


/*SubjectTypes(命名空间：IdentityServer4.Models.SubjectTypes)*/
Vue.filter('SubjectTypes', function (value) {
  if (!value) return '';
  return enums.SubjectTypes.getText(parseInt(value));
});


/*AccessTokenType(命名空间：IdentityServer4.Models.AccessTokenType)*/
Vue.filter('AccessTokenType', function (value) {
  if (!value) return '';
  return enums.AccessTokenType.getText(parseInt(value));
});


/*TokenUsage(命名空间：IdentityServer4.Models.TokenUsage)*/
Vue.filter('TokenUsage', function (value) {
  if (!value) return '';
  return enums.TokenUsage.getText(parseInt(value));
});


/*TokenExpiration(命名空间：IdentityServer4.Models.TokenExpiration)*/
Vue.filter('TokenExpiration', function (value) {
  if (!value) return '';
  return enums.TokenExpiration.getText(parseInt(value));
});


/*CspLevel(命名空间：IdentityServer4.Models.CspLevel)*/
Vue.filter('CspLevel', function (value) {
  if (!value) return '';
  return enums.CspLevel.getText(parseInt(value));
});


/*PasswordHashType(命名空间：Tiantianquan.Infrastructure.Utils.PasswordHashType)*/
Vue.filter('PasswordHashType', function (value) {
  if (!value) return '';
  return enums.PasswordHashType.getText(parseInt(value));
});


/*LockType(命名空间：Tiantianquan.Infrastructure.Webs.Filters.LockType)*/
Vue.filter('LockType', function (value) {
  if (!value) return '';
  return enums.LockType.getText(parseInt(value));
});


/*StateCode(命名空间：Tiantianquan.Infrastructure.Webs.Commons.StateCode)*/
Vue.filter('StateCode', function (value) {
  if (!value) return '';
  return enums.StateCode.getText(parseInt(value));
});


/*HttpContentType(命名空间：Tiantianquan.Infrastructure.Webs.Clients.HttpContentType)*/
Vue.filter('HttpContentType', function (value) {
  if (!value) return '';
  return enums.HttpContentType.getText(parseInt(value));
});


/*CardType(命名空间：Tiantianquan.Infrastructure.MockData.Generators.Banks.CardType)*/
Vue.filter('CardType', function (value) {
  if (!value) return '';
  return enums.CardType.getText(parseInt(value));
});


/*RSAType(命名空间：Tiantianquan.Infrastructure.Helpers.Internal.RSAType)*/
Vue.filter('RSAType', function (value) {
  if (!value) return '';
  return enums.RSAType.getText(parseInt(value));
});


/*CustomMenuType(命名空间：Tiantianquan.EducationBureau.Domain.Enums.Wechat.CustomMenuType)*/
Vue.filter('CustomMenuType', function (value) {
  if (!value) return '';
  return enums.CustomMenuType.getText(parseInt(value));
});


/*匹配模式(命名空间：Tiantianquan.EducationBureau.Domain.Enums.Wechat.MatchPatternType)*/
Vue.filter('MatchPatternType', function (value) {
  if (!value) return '';
  return enums.MatchPatternType.getText(parseInt(value));
});


/*MaterialType(命名空间：Tiantianquan.EducationBureau.Domain.Enums.Wechat.MaterialType)*/
Vue.filter('MaterialType', function (value) {
  if (!value) return '';
  return enums.MaterialType.getText(parseInt(value));
});


/*ReplyType(命名空间：Tiantianquan.EducationBureau.Domain.Enums.Wechat.ReplyType)*/
Vue.filter('ReplyType', function (value) {
  if (!value) return '';
  return enums.ReplyType.getText(parseInt(value));
});


/*奖励类别(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.AwardCategoriesType)*/
Vue.filter('AwardCategoriesType', function (value) {
  if (!value) return '';
  return enums.AwardCategoriesType.getText(parseInt(value));
});


/*著作中本人角色(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.BookMyRoleType)*/
Vue.filter('BookMyRoleType', function (value) {
  if (!value) return '';
  return enums.BookMyRoleType.getText(parseInt(value));
});


/*论文收录情况(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.EssayCollectionType)*/
Vue.filter('EssayCollectionType', function (value) {
  if (!value) return '';
  return enums.EssayCollectionType.getText(parseInt(value));
});


/*指导学生竞赛获奖本人角色(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.GuidanceStudentCompetitionWinningMyRoleType)*/
Vue.filter('GuidanceStudentCompetitionWinningMyRoleType', function (value) {
  if (!value) return '';
  return enums.GuidanceStudentCompetitionWinningMyRoleType.getText(parseInt(value));
});


/*本人排名(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.IRankType)*/
Vue.filter('IRankType', function (value) {
  if (!value) return '';
  return enums.IRankType.getText(parseInt(value));
});


/*教师资格分类(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.JSZGZFLType)*/
Vue.filter('JSZGZFLType', function (value) {
  if (!value) return '';
  return enums.JSZGZFLType.getText(parseInt(value));
});


/*教职工当前状态代码(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.JZGDQZTType)*/
Vue.filter('JZGDQZTType', function (value) {
  if (!value) return '';
  return enums.JZGDQZTType.getText(parseInt(value));
});


/*著作类别(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.LiteratureType)*/
Vue.filter('LiteratureType', function (value) {
  if (!value) return '';
  return enums.LiteratureType.getText(parseInt(value));
});


/*婚姻状况(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.MaritalStatusType)*/
Vue.filter('MaritalStatusType', function (value) {
  if (!value) return '';
  return enums.MaritalStatusType.getText(parseInt(value));
});


/*项目中本人角色(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.MyRoleInTheProjectType)*/
Vue.filter('MyRoleInTheProjectType', function (value) {
  if (!value) return '';
  return enums.MyRoleInTheProjectType.getText(parseInt(value));
});


/*本人角色(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.MyRoleType)*/
Vue.filter('MyRoleType', function (value) {
  if (!value) return '';
  return enums.MyRoleType.getText(parseInt(value));
});


/*民族(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.NationType)*/
Vue.filter('NationType', function (value) {
  if (!value) return '';
  return enums.NationType.getText(parseInt(value));
});


/*健康状况(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.PhysicalConditionType)*/
Vue.filter('PhysicalConditionType', function (value) {
  if (!value) return '';
  return enums.PhysicalConditionType.getText(parseInt(value));
});


/*政治面貌(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.PoliticsType)*/
Vue.filter('PoliticsType', function (value) {
  if (!value) return '';
  return enums.PoliticsType.getText(parseInt(value));
});


/*项目来源(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.ProjectSourceType)*/
Vue.filter('ProjectSourceType', function (value) {
  if (!value) return '';
  return enums.ProjectSourceType.getText(parseInt(value));
});


/*项目类型(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.ProjectType)*/
Vue.filter('ProjectType', function (value) {
  if (!value) return '';
  return enums.ProjectType.getText(parseInt(value));
});


/*奖励级别(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.RewardGradeType)*/
Vue.filter('RewardGradeType', function (value) {
  if (!value) return '';
  return enums.RewardGradeType.getText(parseInt(value));
});


/*奖励等级(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.RewardLevelType)*/
Vue.filter('RewardLevelType', function (value) {
  if (!value) return '';
  return enums.RewardLevelType.getText(parseInt(value));
});


/*授奖国家(地区)(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.StateOfPrizesType)*/
Vue.filter('StateOfPrizesType', function (value) {
  if (!value) return '';
  return enums.StateOfPrizesType.getText(parseInt(value));
});


/*学科领域(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.SubjectAreasType)*/
Vue.filter('SubjectAreasType', function (value) {
  if (!value) return '';
  return enums.SubjectAreasType.getText(parseInt(value));
});


/*培训类别(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.TrainingClassesType)*/
Vue.filter('TrainingClassesType', function (value) {
  if (!value) return '';
  return enums.TrainingClassesType.getText(parseInt(value));
});


/*参培层次(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.TrainingLevelType)*/
Vue.filter('TrainingLevelType', function (value) {
  if (!value) return '';
  return enums.TrainingLevelType.getText(parseInt(value));
});


/*学历(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.XLType)*/
Vue.filter('XLType', function (value) {
  if (!value) return '';
  return enums.XLType.getText(parseInt(value));
});


/*中小学课程(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.ZXXKCType)*/
Vue.filter('ZXXKCType', function (value) {
  if (!value) return '';
  return enums.ZXXKCType.getText(parseInt(value));
});


/*聘任专业技术职务(命名空间：Tiantianquan.EducationBureau.Domain.Enums.TPDS.ZYJSZWType)*/
Vue.filter('ZYJSZWType', function (value) {
  if (!value) return '';
  return enums.ZYJSZWType.getText(parseInt(value));
});


/*机构级别(命名空间：Tiantianquan.EducationBureau.Domain.Enums.SC.CompanyLevelType)*/
Vue.filter('CompanyLevelType', function (value) {
  if (!value) return '';
  return enums.CompanyLevelType.getText(parseInt(value));
});


/*机构类别(命名空间：Tiantianquan.EducationBureau.Domain.Enums.SC.CompanyType)*/
Vue.filter('CompanyType', function (value) {
  if (!value) return '';
  return enums.CompanyType.getText(parseInt(value));
});


/*学生家长关系(命名空间：Tiantianquan.EducationBureau.Domain.Enums.SC.StudentParentMapType)*/
Vue.filter('StudentParentMapType', function (value) {
  if (!value) return '';
  return enums.StudentParentMapType.getText(parseInt(value));
});


/*单位类别(命名空间：Tiantianquan.EducationBureau.Domain.Enums.SC.UnitType)*/
Vue.filter('UnitType', function (value) {
  if (!value) return '';
  return enums.UnitType.getText(parseInt(value));
});


/*用户类别(命名空间：Tiantianquan.EducationBureau.Domain.Enums.Privilege.UserType)*/
Vue.filter('UserType', function (value) {
  if (!value) return '';
  return enums.UserType.getText(parseInt(value));
});


/*ClientType(命名空间：Tiantianquan.EducationBureau.Domain.Enums.IdentityServer.ClientType)*/
Vue.filter('ClientType', function (value) {
  if (!value) return '';
  return enums.ClientType.getText(parseInt(value));
});


/*HashType(命名空间：Tiantianquan.EducationBureau.Domain.Enums.IdentityServer.HashType)*/
Vue.filter('HashType', function (value) {
  if (!value) return '';
  return enums.HashType.getText(parseInt(value));
});


/*性别(命名空间：Tiantianquan.EducationBureau.Domain.Enums.Common.SexType)*/
Vue.filter('SexType', function (value) {
  if (!value) return '';
  return enums.SexType.getText(parseInt(value));
});


/*YesNoType(命名空间：Tiantianquan.EducationBureau.Domain.Enums.Common.YesNoType)*/
Vue.filter('YesNoType', function (value) {
  if (!value) return '';
  return enums.YesNoType.getText(parseInt(value));
});



// WEBPACK FOOTER //
// ./src/filters.js